var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('FaceCapture',{attrs:{"accessId":_vm.accessId,"client":_vm.client},on:{"cancel":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }